import { render } from "./resetpin.vue?vue&type=template&id=22366caf"
import script from "./resetpin.vue?vue&type=script&lang=js"
export * from "./resetpin.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__